import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CambioDeURL from '../../../../funciones/gestionURL';
import { useNavigate, useLocation } from 'react-router-dom';

export default function SelectDinamico({parametroURL, valorInicial,etiqueta }) {
    const navigate = useNavigate();
    const location = useLocation();

    const conseguirValorURL = () => {
        const params = new URLSearchParams(location.search);
        return params.get(parametroURL) || valorInicial;
    };

    const [valor, setValor] = useState(conseguirValorURL);
    const cambioURL = CambioDeURL(parametroURL);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const valorActualURL = params.get(parametroURL) || valorInicial;
        setValor(valorActualURL);
    }, [location.search, parametroURL, valorInicial]);

    const handleChange = (event) => {
        const opcionSeleccionada = event.target.value;
        setValor(opcionSeleccionada);
        const nuevaURL = cambioURL(opcionSeleccionada);
        navigate(nuevaURL);
    };

    return (
        <FormControl sx={{ ml: 1, width: 150 }}>
            <InputLabel id={`select-label-${parametroURL}`}>{etiqueta}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={valor}
                label={parametroURL}
                onChange={handleChange}
            >
                <MenuItem key={2} value={2}>
                    Todos
                </MenuItem>
                <MenuItem key={1} value={1}>
                    Si
                </MenuItem>
                <MenuItem key={0} value={0}>
                    No
                </MenuItem>
            </Select>
        </FormControl>
    );
}
